import { type Config, Envs } from '../interfaces';

export const TEST_CONFIG_PART: Partial<Config> = {
  environment: Envs.test,
  gtmContainerId: 'GTM-MLMGX9C',
  auth: {
    oktaTokenUrl: 'https://login.qa.circlek.com/oauth2/aus2pnx40clt6Yygg1d7/v1/token',
    oktaIntrospectUrl: 'https://login.qa.circlek.com/oauth2/aus2pnx40clt6Yygg1d7/v1/introspect',
    oktaClientId: '0oawmgleirAKvaJkf1d7',
    redirectUri: 'https://marketplace-qa.icweb-test.alpaque.net',
    oktaRedirectUri: 'https://marketplace-qa.icweb-test.alpaque.net/login/callback',
    webAuthSignInUrl: 'https://okta-auth-cloudfront-qa.webo-test.alpaque.net/en?appId=bltce92f3cd1ce7591d',
  },
  rewardsContent: {
    baseUrl: 'https://marketplace-qa.icweb-test.alpaque.net',
  },
  loyaltyApiUrl: 'https://api.uat.circlek.com/us/loyalty',
  monthlyStatementContent: { baseUrl: '' },
};
